<template>
  <div class="msg-root">
    <div id="layout-wrapper" class="msg-layout-wrapper">
      <div class="msg-topbar">
        <div class="container d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center gap-3">
            <a href="javascript:void(0)" @click="$router.push('/')">
              <img src="assets/images/flockr_logo.png" alt="Flockr" style="height:32px;" />
            </a>
            <span class="msg-title">Messages</span>
          </div>
          <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="btn btn-sm btn-outline-warning">Dashboard</a>
        </div>
      </div>

      <div class="container msg-container">
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-warning"></div>
        </div>

        <div v-else-if="conversations.length === 0" class="text-center py-5">
          <i class="mdi mdi-message-text-outline msg-empty-icon"></i>
          <p class="mt-3 msg-empty-text">No conversations yet</p>
          <p class="msg-empty-subtext">Messages from offers and orders will appear here</p>
        </div>

        <div v-else>
          <div v-for="c in conversations" :key="c.id" class="msg-conv" @click="$router.push('/messages/' + c.id)">
            <div class="msg-avatar-wrap">
              <user-avatar :src="c.other_avatar" :name="c.other_name" size="md" />
              <div v-if="c.unread_count > 0" class="msg-unread-dot"></div>
              <div v-if="c.other_online === '1' || c.other_online === 1" class="msg-online-dot"></div>
            </div>

            <div class="flex-fill" style="min-width:0;">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <span class="msg-name" :class="{ unread: c.unread_count > 0 }">{{ c.other_name || 'User' }}</span>
                <span class="msg-time">{{ timeAgo(c.last_message_at || c.updated_at) }}</span>
              </div>

              <div class="msg-preview" :class="{ unread: c.unread_count > 0 }">
                {{ formatPreview(c.last_message_preview) }}
              </div>

              <div v-if="c.context_type && c.context_type !== 'general'" class="msg-context">
                <i class="mdi" :class="c.context_type === 'order' ? 'mdi-receipt' : 'mdi-tag'"></i>
                {{ c.context_type === 'order' ? 'Order' : 'Listing' }}
              </div>
            </div>

            <div v-if="c.unread_count > 0" class="msg-badge">{{ c.unread_count }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
html[data-theme="light"] body {
  background: #F7F5F2 !important;
  color: #1A1A1A !important;
}

html[data-theme="dark"] body {
  background: #0A0A0A !important;
  color: #F5F0E8 !important;
}

html[data-theme="light"] .msg-root,
html[data-theme="light"] .msg-layout-wrapper,
html[data-theme="light"] .msg-root #layout-wrapper,
html[data-theme="light"] .msg-root .msg-container {
  background: #F7F5F2 !important;
  color: #1A1A1A !important;
}

html[data-theme="dark"] .msg-root,
html[data-theme="dark"] .msg-layout-wrapper,
html[data-theme="dark"] .msg-root #layout-wrapper,
html[data-theme="dark"] .msg-root .msg-container {
  background: #0A0A0A !important;
  color: #F5F0E8 !important;
}
</style>

<style>
:root {
  --fm-h: #F5F0E8;
  --fm-s: #6B6356;
  --fm-m: #A09888;
  --fm-bg1: #141414;
  --fm-bg2: #0F0F0F;
  --fm-bg3: #1E1E1E;
  --fm-br: #1E1E1E;
}

html[data-theme="light"] {
  --fm-h: #1A1A1A;
  --fm-s: #777;
  --fm-m: #555;
  --fm-bg1: #FFFFFF;
  --fm-bg2: #F7F5F2;
  --fm-bg3: #F0EBE4;
  --fm-br: #E8E2DA;
}
</style>

<style scoped>
.msg-root,
.msg-layout-wrapper {
  background: var(--fm-bg2, #0F0F0F) !important;
  min-height: 100vh;
  color: var(--fm-h, #F5F0E8);
}

.msg-topbar {
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 12px 0;
  background: var(--fm-bg1, #141414) !important;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--fm-br, #1E1E1E);
}

.msg-title {
  color: var(--fm-h, #F5F0E8);
  font-weight: 600;
}

.msg-container {
  padding-top: 80px;
  padding-bottom: 60px;
  max-width: 700px;
}

.msg-conv {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  background: var(--fm-bg1, #141414);
  border: 1px solid var(--fm-br, #1E1E1E);
  border-radius: 12px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all .2s;
}

.msg-conv:hover {
  border-color: #BFA164;
  transform: translateX(2px);
}

.msg-avatar-wrap {
  position: relative;
  flex-shrink: 0;
}

.msg-online-dot {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #50C878;
  border: 2px solid var(--fm-bg2, #0A0A0A);
}

.msg-unread-dot {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #50C878;
  border: 2px solid var(--fm-bg1, #141414);
}

.msg-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--fm-m, #A09888);
}

.msg-name.unread {
  color: var(--fm-h, #F5F0E8);
}

.msg-time {
  font-size: 11px;
  color: var(--fm-s, #777);
  white-space: nowrap;
}

.msg-preview {
  font-size: 12px;
  color: var(--fm-s, #6B6356);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.msg-preview.unread {
  color: var(--fm-m, #A09888);
  font-weight: 500;
}

.msg-context {
  font-size: 10px;
  color: var(--fm-s, #777);
  margin-top: 4px;
}

.msg-context i {
  font-size: 11px;
  margin-right: 2px;
}

.msg-badge {
  background: #BFA164;
  color: #0A0A0A;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 12px;
  flex-shrink: 0;
}

.msg-empty-icon {
  font-size: 56px;
  color: var(--fm-s, #6B6356);
}

.msg-empty-text {
  color: var(--fm-s, #6B6356);
}

.msg-empty-subtext {
  color: var(--fm-s, #777);
  font-size: 13px;
}

@media (max-width: 768px) {
  .msg-container {
    padding-top: 70px;
  }
}
</style>

<script>
/* eslint-disable */
import { execute, flocker, uploads } from "@/api";
import UserAvatar from "@/components/flockr-users/UserAvatar.vue";

export default {
  name: "MessagesInbox",
  components: { UserAvatar },
  data() {
    return {
      darkMode: (document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || 'dark') !== 'light',
      themeObserver: null,
      loading: true,
      conversations: []
    };
  },
  mounted() {
    this.syncTheme();
    this.themeObserver = new MutationObserver(this.syncTheme);
    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });
    this.load();
  },
  beforeUnmount() {
    if (this.themeObserver) {
      this.themeObserver.disconnect();
    }
  },
  methods: {
    syncTheme() {
      var t = document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || 'dark';
      window.__flockrSetTheme(t);
      this.darkMode = t !== 'light';

      if (document.body) {
        document.body.setAttribute('data-sidebar', this.darkMode ? 'dark' : 'light');
        document.body.style.background = this.darkMode ? '#0A0A0A' : '#F7F5F2';
        document.body.style.color = this.darkMode ? '#F5F0E8' : '#1A1A1A';
      }

      var el = this.$el;
      if (el) {
        el.style.background = this.darkMode ? '#0A0A0A' : '#F7F5F2';
        el.style.color = this.darkMode ? '#F5F0E8' : '#1A1A1A';
      }
    },

    pu(p) {
      if (!p) return '';
      if (p.startsWith && p.startsWith('http')) return p;
      return uploads + String(p).replace('uploads/', '');
    },

    initials(n) {
      if (!n) return '?';
      return n.split(' ').map(function(w) { return w.charAt(0); }).join('').substring(0, 2).toUpperCase();
    },

    timeAgo(d) {
      if (!d) return '';
      var s = Math.floor((Date.now() - new Date(d).getTime()) / 1000);
      if (s < 60) return 'now';
      if (s < 3600) return Math.floor(s / 60) + 'm';
      if (s < 86400) return Math.floor(s / 3600) + 'h';
      if (s < 604800) return Math.floor(s / 86400) + 'd';
      return new Date(d).toLocaleDateString('en-KE', { day: 'numeric', month: 'short' });
    },

    formatPreview(p) {
      if (!p) return 'No messages yet';
      var trimmed = p.trim();

      if (trimmed.indexOf('"_type":"listing_card"') > -1 || trimmed.indexOf('"_type\\":"listing_card') > -1) {
        var m = trimmed.match(/"title"\s*:\s*"([^"]+)"/);
        var title = m ? m[1] : 'Listing';
        return '\uD83D\uDCE6 ' + title + ' — Interested in this listing';
      }

      if (trimmed.indexOf('"_type":"location"') > -1 || trimmed.indexOf('"_type\\":"location') > -1) {
        return '\uD83D\uDCCD Shared location';
      }

      if (trimmed.charAt(0) === '{') {
        try {
          var d = JSON.parse(trimmed);
          if (d._type === 'listing_card') return '\uD83D\uDCE6 ' + (d.title || 'Listing') + ' — Interested in this listing';
          if (d._type === 'location') return '\uD83D\uDCCD Shared location';
          return d.text || 'Message';
        } catch (e) {
          var mt = trimmed.match(/"title"\s*:\s*"([^"]+)"/);
          if (mt) return '\uD83D\uDCE6 ' + mt[1];
          return 'Sent an attachment';
        }
      }

      if (trimmed.match(/^\d+:\d+$/)) return '\uD83C\uDFA4 Voice note';
      return p;
    },

    async load() {
      var userId = sessionStorage.getItem('userId');
      if (!userId) {
        this.$router.push('/login');
        return;
      }

      try {
        var cached = sessionStorage.getItem('inbox_conversations');
        if (cached) {
          this.conversations = JSON.parse(cached);
          this.loading = false;
        }
      } catch (e) {}

      try {
        var f = new FormData();
        f.append('function', 'getConversations');
        f.append('userId', userId);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          this.conversations = r.data.data.conversations || [];
          try {
            sessionStorage.setItem('inbox_conversations', JSON.stringify(this.conversations));
          } catch (e) {}
        }
      } catch (e) {
        console.error(e);
      }

      this.loading = false;
    }
  }
};
</script>
